export const UnitTypes = {
    buy: 1,
    rent: 2,
    companySpace: 3,
    parking: 4,
    storage: 5,
};
